module.exports = __webpack_public_path__ + "img/g8.af1895ba.jpg";